export default __webpack_public_path__ + "web/react/components/app-download-promo/image-assets/MOBILE.4d51b30e2beb0b91fc72dd2f1b83235c.jpg";